(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/components/teams-overview.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/components/teams-overview.js');
'use strict';

var _svs$utils$url$queryS;
const {
  Grid,
  GridCol,
  GridRow
} = svs.ui.ReactGrid;
const {
  ReactButton: Button
} = svs.ui;
const {
  routes
} = svs.arena.constants;
const {
  TeamsListItem
} = svs.arena.pages.teams.components;
const {
  fetchTeamsDetails,
  fetchTeamsInviteId
} = svs.arena.store.teams.actions;
const preselectedTeam = parseInt((_svs$utils$url$queryS = svs.utils.url.queryString) === null || _svs$utils$url$queryS === void 0 ? void 0 : _svs$utils$url$queryS.syndicateId, 10);
const TeamsOverview = _ref => {
  let {
    teams
  } = _ref;
  const dispatch = ReactRedux.useDispatch();
  const history = ReactRouterDOM.useHistory();
  React.useEffect(() => {
    if ((teams === null || teams === void 0 ? void 0 : teams.length) > 0) {
      svs.arena.logger.debug('TeamsOverview, useEffect...fetchTeamsInviteId and fetchTeamsDetails for all teams...');
      dispatch(fetchTeamsInviteId());
      dispatch(fetchTeamsDetails());
    }
  }, [dispatch, teams]);
  return React.createElement("div", {
    className: "main-content-constrained"
  }, React.createElement("div", {
    className: "margin-1"
  }, React.createElement(Grid, null, React.createElement(GridRow, {
    className: "u-text-left u-flex-justify-content-center"
  }, teams === null || teams === void 0 ? void 0 : teams.map(team =>
  React.createElement(GridCol, {
    key: team === null || team === void 0 ? void 0 : team.syndicateId,
    xs: 12,
    sm: 10,
    am: 8,
    md: {
      col: 6
    },
    lg: {
      col: 4
    }
  }, React.createElement(TeamsListItem, {
    isPreselected: preselectedTeam === (team === null || team === void 0 ? void 0 : team.syndicateId),
    team: team
  })))), React.createElement(GridRow, {
    className: "u-flex-justify-content-center"
  }, React.createElement(GridCol, {
    className: "align-center margin-bottom-1"
  }, React.createElement(Button, {
    onClick: () => history.push(routes.TEAMS_CREATE),
    transparent: true
  }, "Skapa ett nytt lag"))))));
};
svs.arena.pages.teams.components.TeamsOverview = TeamsOverview;

 })(window);